module.exports = __webpack_public_path__ + "img/moren@2x.f48efe41.png";